import { z } from 'zod';

// ---------------------------------------------------------------------------
// Outbound Schema
// ---------------------------------------------------------------------------

export const outboundSchemaQuery = z.object({
  type: z.enum(['whatsapp', 'email', 'app', 'all']).default('all'),
});

// ---------------------------------------------------------------------------
// Template Params & Queries
// ---------------------------------------------------------------------------

export const templateIdParam = z.object({
  id: z.string().uuid(),
});

export const listTemplatesQuery = z.object({
  hub_id: z.string().uuid(),
  connection_id: z.string().uuid(),
});

export const deleteTemplateQuery = z.object({
  hub_id: z.string().uuid(),
  connection_id: z.string().uuid(),
});

export const templateStatusQuery = z.object({
  hub_id: z.string().uuid(),
  connection_id: z.string().uuid(),
});

export const createTemplateBody = z.object({
  hub_id: z.string().uuid(),
  connection_id: z.string().uuid(),
}).passthrough();

export const updateTemplateBody = z.object({}).passthrough();

export const submitTemplateBody = z.object({
  hub_id: z.string().uuid(),
  connection_id: z.string().uuid(),
}).passthrough();

export const testTemplateBody = z.object({
  hub_id: z.string().uuid(),
  connection_id: z.string().uuid(),
}).passthrough();

// ---------------------------------------------------------------------------
// Inferred types
// ---------------------------------------------------------------------------

export type OutboundSchemaQuery = z.infer<typeof outboundSchemaQuery>;
export type TemplateIdParam = z.infer<typeof templateIdParam>;
export type ListTemplatesQuery = z.infer<typeof listTemplatesQuery>;
export type DeleteTemplateQuery = z.infer<typeof deleteTemplateQuery>;
export type TemplateStatusQuery = z.infer<typeof templateStatusQuery>;
export type CreateTemplateBody = z.infer<typeof createTemplateBody>;
export type UpdateTemplateBody = z.infer<typeof updateTemplateBody>;
export type SubmitTemplateBody = z.infer<typeof submitTemplateBody>;
export type TestTemplateBody = z.infer<typeof testTemplateBody>;

// ---------------------------------------------------------------------------
// Response types
// ---------------------------------------------------------------------------

/** Connection entry in the outbound schema */
export interface OutboundSchemaConnection {
  connection_id: string;
  connector_name: string;
  connection_display_name?: string;
  connector_type: string;
  service_name: string;
  hub_id: string;
  enabled: boolean;
}

/** Template operation result — returned by all template endpoints */
export interface TemplateOperationResult {
  [key: string]: unknown;
}

/** POST /templates — create template (when a template_id is returned) */
export interface CreateTemplateResponse {
  template_id: string;
}

/** GET /schema */
export interface GetOutboundSchemaResponse {
  data: {
    flat: {
      organizations: Array<{
        organization_id: string;
        organization_name: string;
      }>;
      hubsByOrg: Record<string, Array<{
        hub_id: string;
        hub_name: string;
      }>>;
      connectionsByHub: Record<string, OutboundSchemaConnection[]>;
    };
    lastUpdated: string;
  };
}
